export default {
  title: 'Informações de contacto',
  form: {
    customer_first_name: {
      placeholder: 'Primeiro nome',
    },
    customer_last_name: {
      placeholder: 'Apelido',
    },
    customer_email: {
      placeholder: 'Endereço de email',
    },
    customer_phone_number: {
      placeholder: 'Número de telefone',
    },
  },
  validation: {
    customer_first_name: {
      required: 'Por favor introduza o seu primeiro nome',
    },
    customer_last_name: {
      required: 'Por favor introduza o seu apelido',
    },
    customer_email: {
      required: 'Por favor introduza o seu email',
    },
    customer_phone_number: {
      required: 'Por favor introduza o seu número de telefone',
    },
  },
};
